import {useState} from "react"

interface UseVideoListOptions {
   initialVideos?: string[] | null
   onError?: (message: string | false) => void
}

export function useVideoList(options: UseVideoListOptions = {}) {
   const {initialVideos = [], onError} = options

   const [videoInput, setVideoInput] = useState("")
   const [videosList, setVideosList] = useState<string[]>(initialVideos ?? [])

   const addVideo = () => {
      const trimmedVideo = videoInput.trim()

      if (onError) onError(false)

      if (trimmedVideo === "") {
         onError?.("Ingresa el URL del video")
         return false
      }

      setVideosList((prevVideosList) => [...prevVideosList, trimmedVideo])
      setVideoInput("")
      return true
   }

   const removeVideo = (index: number) => {
      setVideosList((prevVideosList) => prevVideosList.filter((_, i) => i !== index))
   }

   const resetVideos = (videos: string[] = []) => {
      setVideosList(videos)
      setVideoInput("")
   }

   return {
      videoInput,
      setVideoInput,
      videosList,
      setVideosList,
      addVideo,
      removeVideo,
      resetVideos,
   }
}
